import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T, { useTranslation } from '@wojtekmaj/react-t';
import { QrCodeIcon } from 'lucide-react';

import Dialog from '@rewardopl/react-ui/dialog';

import { Button, CodeWrapper, Text } from './your_code_button.styles';

import StaticCode from '../../common/static_code';

import { currentUserState } from '../../../store';

export default function YourCodeButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = useAtomValue(currentUserState);
  const yourCodeString = useTranslation('Your sweet code');

  function openDialog() {
    navigate('#your-code', {
      state: {
        ...(location.state as Record<string, unknown>),
        scrollToTop: false,
      },
    });
  }

  const closeDialog = useCallback(() => {
    navigate(
      {
        ...location,
        hash: '',
      },
      { state: location.state },
    );
  }, [location, navigate]);

  return (
    <>
      <Button onClick={openDialog} title={yourCodeString} type="button">
        <QrCodeIcon />
      </Button>
      <Dialog
        isOpen={location.hash === '#your-code'}
        onDismiss={closeDialog}
        title="Your sweet code"
      >
        <Text>
          <T>
            This is your unique QR code. Show it at the checkout every time you shop at Sweet
            Factory Store to earn more sweets.
          </T>
        </Text>
        <CodeWrapper>
          <StaticCode color="var(--black)" id={currentUser._id} />
        </CodeWrapper>
        <Text>
          <T>
            For every zloty you spend you will receive one sweet. Exchange them for any prizes or
            coupons you choose, which you will always find on the main screen of our application.
          </T>
        </Text>
      </Dialog>
    </>
  );
}
